<template>
  <v-container class="home">
    <video-intro :video="currentVideo" />
    <v-row justify="center">
      <v-column class="text-center">
      Further tutorial web pages:
    <v-pagination
      v-model="page"
      :length="videos.length"
      circle
    ></v-pagination>
      </v-column>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

import VideoIntro from '@/components/VideoIntro'
import imgVideo1Intro from '@/assets/video1-intro.png'
import imgVideo2Intro from '@/assets/video2-intro.png'
import imgVideo3Intro from '@/assets/video3-intro.png'
import video1Preview from '@/assets/video1-preview.gif'
import video2Preview from '@/assets/video2-preview.gif'
import video3Preview from '@/assets/video3-preview.gif'

export default {
  name: 'Home',
  components: {
    VideoIntro
  },
  data: () => ({
    //page: 1,
    videos: [
      {
        id: 'video1',
        title: 'Testing a combustion reaction mechanism',
        description: 'A detailed combustion reaction mechanism can be tested quickly and easily on a multicore PC using RKD format XML files and the graphical user interface of our Optima++ code.',
        youtubeId: 'RCgeivBgIG4',
        image: imgVideo1Intro,
        preview: video1Preview,
        views: 786,
        rate: 4,
        rateCount: 69
      },
      {
        id: 'video2',
        title: 'Using a computer cluster for testing a combustion reaction mechanism',
        description: 'Simulations with large number of experimental data points or flame simulations requiring much computer time can be carried out in an effective way on a computer cluster using RKD format XML files and the command line operation mode of Optima++.',
        image: imgVideo2Intro,
        youtubeId: 'CXqTtSmTUyE',
        preview: video2Preview,
        views: 1574,
        rate: 5,
        rateCount: 42
      },
      {
        id: 'video3',
        title: 'Encoding combustion experimental data',
        description: 'Combustion experimental data found in an article or your own experimental data can be encoded easily in an RKD-format XML datafile using the Optima++ code. This video shows how. ',
        image: imgVideo3Intro,
        youtubeId: 'ctehI9Ezxac',
        preview: video3Preview,
        views: 17,
        rate: 5,
        rateCount: 42
      },
    ],
  }),
  computed: {
    currentVideo () {
      return this.videos[this.page - 1]
    },
    page: {
      set (page) {
        this.$router.replace({ name: "Home", query: { vii: page}})
      },
      get () {
        const queryPage = this.$route.query.vii
        if (queryPage) {
          const page = Number(queryPage)
          if (page <= this.videos.length && page > 0) {
            return page
          }
        }
        this.$router.replace({ name: "Home", query: { vii: 1}})
        return 1
      }
    }
  },
  /*mounted() {
    const queryPage = this.$route.query.vidi
    if (queryPage) {
      const page = Number(queryPage)
      if ( page < this.videos.length && page > 0) {
        this.page = page
        return
      }
    }
    this.$router.replace({ name: "Home", query: { vidi: this.page}})
  },
  watch: {
    page () {
      if (this.$route.query.vidi != this.page) {
        this.$router.replace({ name: "Home", query: { vidi: this.page}})
      }
    }
  }*/
}
</script>
